export default "__VITE_ASSET__Du71Yz3N__"